<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <form class="float-right">
              <button type="button" class="btn btn-link ml-2" @click="creditInvoice"  v-if="invoice.canCredit">
                <i class="mdi mdi-undo-variant"></i> Koosta kreeditarve
              </button>
              <button type="button" class="btn btn-link ml-2" @click="downloadInvoice">
                <i class="mdi mdi-file-pdf"></i> PDF
              </button>

              <submit-button class="btn ml-2" variant="link" @click.prevent="cloneInvoice" v-if="invoice.canClone">
                <i class="mdi mdi-content-copy"></i> Klooni
              </submit-button>

              <button type="button" class="btn btn-primary ml-2" @click="sendInvoice"  v-if="!isDraft">
                <i class="mdi mdi-email"></i> Saada arve...
              </button>
            </form>
          </div>
          <h4 class="page-title">{{invoice.type}} nr. {{invoice.number}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-xl-6">
        <div class="card mb-3">
          <div class="card-body">
            <h4 class="card-title mb-2">Arve saaja</h4>

            <div class="alert alert-warning alert-card-edge-to-edge" v-for="memo in invoice.clientMemos">
              {{memo.message}}<br>
              <small class="text-muted">{{memo.createdBy}} {{memo.createdAt | formatDateTime}} </small>
            </div>

            <a @click="goToClient" class="h3 d-block mb-2">
              {{invoice.client.name}}
            </a>

            <div class="row">
              <div class="col-8">
                <div class="data-list">
                  <dl>
                    <dt>Aadress</dt>
                    <dd>{{invoice.client.address.street}} {{invoice.client.address.city}}
                      {{invoice.client.address.locality}} {{invoice.client.address.zip}}
                      {{invoice.client.address.country.text}}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="col-4">
                <div class="data-list">
                  <dl>
                    <dt>KMKR</dt>
                    <dd>{{invoice.vatin}}</dd>
                  </dl>
                </div>
              </div>
            </div>

            <div class="row" v-if="invoice.receipientDetails">
              <div class="col-12">
                <div class="data-list">
                  <dl>
                    <dt>Saaja detailid</dt>
                    <dd>{{invoice.receipientDetails}}</dd>
                  </dl>
                </div>
              </div>
            </div>

            <a href="#" @click.prevent="changeClient" class="card-link text-primary" v-if="isDraft">
              <i class="mdi mdi-pencil mr-1"></i> Muuda saajat
            </a>
            <a href="#" @click.prevent="changeVatin" class="card-link text-primary" v-if="isDraft">
              <i class="mdi mdi-pencil mr-1"></i> Muuda KMKR
            </a>
            <a href="#" @click.prevent="changeReceipientDetails" class="card-link text-primary" v-if="isDraft">
              <i class="mdi mdi-pencil mr-1"></i> Saaja detailid
            </a>

          </div>
          <div class="card-body bg-light py-2" v-if="invoice.lastEmail">
            <div class="row">
              <div class="col-6">
                <div class="data-list">
                  <dl>
                    <dt>Saadetud</dt>
                    <dd>
                      {{invoice.lastEmail.sentAt | formatDateTime}}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="col-6">
                <div class="data-list">
                  <dl>
                    <dt>Saajale</dt>
                    <dd>{{invoice.lastEmail.recipients}}</dd>
                  </dl>
                </div>
              </div>
              <div class="col-12">
                <div class="data-list">
                  <dl>
                    <dt>Manused</dt>
                    <dd>
                      <template v-for="attachment in invoice.lastEmail.attachments">
                        <span class="badge badge-secondary-light mr-1">{{attachment}}</span>
                      </template>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-12 col-xl-6">
        <div class="card mb-3">
          <div class="card-body">
            <h4 class="card-title mt-0 mb-2">Üldandmed</h4>

            <div class="alert alert-warning alert-card-edge-to-edge" v-for="memo in invoice.internalMemos">

              <span class="float-right">
                <button type="button" class="btn btn-link" @click="deleteInternalMemo(memo.id)">
                  <i class="mdi mdi-delete"></i>
                </button>
              </span>
              {{memo.message}}<br>
              <small class="text-muted">{{memo.createdBy}} {{memo.createdAt | formatDateTime}} </small>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="data-list">
                  <dl v-if="invoice.creditedInvoiceId">
                    <dt>Krediteeritav arve</dt>
                    <dd><router-link :to="`/invoices/${invoice.creditedInvoiceId}`">{{invoice.creditedInvoiceNumber}}</router-link></dd>
                  </dl>
                  <dl v-if="invoice.creditInvoices && invoice.creditInvoices.length">
                    <dt>Kreeditarved</dt>
                    <dd>
                      <template v-for="credit in invoice.creditInvoices">
                        <router-link :to="`/invoices/${credit.id}`">{{credit.number}}</router-link> &nbsp;
                      </template>
                    </dd>
                  </dl>
                  <dl>
                    <dt>Arve loodud</dt>
                    <dd>{{invoice.createdAt | formatDate}}</dd>
                  </dl>
                  <dl v-if="invoice.invoiceDate">
                    <dt>Kinnitatud</dt>
                    <dd>{{invoice.invoiceDate | formatDate}}</dd>
                  </dl>
                  <dl>
                    <dt>Arve koostaja</dt>
                    <dd>{{invoice.createdBy.name}}</dd>
                  </dl>
                  <dl>
                    <dt>Telefoninumber</dt>
                    <dd>{{invoice.createdBy.phone}}</dd>
                  </dl>
                </div>
              </div>
              <div class="col-6">
                <div class="data-list">
                  <dl>
                    <dt>Staatus</dt>
                    <dd>
                      <span :class="'badge badge-lg badge-' + invoiceStatusStyleClass(invoice.statusCode)">
                        {{invoice.status}}
                      </span>

                      <permission name="InvoiceUnconfirm" v-if="canUnconfirm">
                        <a tabindex="0" @click="unConfirm" class="small">
                          <i class="mdi mdi-undo mx-1"></i>Ava arve
                        </a>
                      </permission>

                      <permission name="InvoiceSetCreditPaid" v-if="canSetCreditPaid">
                        <a @click.prevent="setCreditPaid" class="small">
                          <i class="mdi mdi-check"></i> Makstuks
                        </a>
                      </permission>

                    </dd>
                  </dl>
                  <dl v-if="invoice.paidAt">
                    <dt>Makstud</dt>
                    <dd>{{invoice.paidAt | formatDate}}</dd>
                  </dl>
                  <dl v-if="invoice.dueDate">
                    <dt>Tähtaeg</dt>
                    <dd>{{invoice.dueDate | formatDate}}</dd>
                  </dl>
                  <dl>
                    <dt>Tähtaeg päevades</dt>
                    <dd>{{invoice.paymentDueDays != undefined ? invoice.paymentDueDays : 'määramata'}}</dd>
                  </dl>
                  <dl v-if="transactions && transactions.balance !== undefined && !isDraft">
                    <dt>Saldo</dt>
                    <dd class="h4">{{transactions.balance | amountWithCurrency}}</dd>
                  </dl>
                  <dl v-if="invoice.exportedAt">
                    <dt>Raamatupidamisse edastatud</dt>
                    <dd>{{invoice.exportedAt | formatDateTime}}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <a @click.prevent="editPaymentDueDays" class="card-link text-primary" v-if="isDraft && !isAdvancePaymentInvoice">
              <i class="mdi mdi-pencil"></i> Tähtaeg
            </a>
            <a @click.prevent="selectInvoicePrefix" class="card-link text-primary" v-if="invoice.canChangePrefix">
              <i class="mdi mdi-pencil"></i> Objekt
            </a>
            <a @click.prevent="addInternalMemo" class="card-link text-primary">
              <i class="mdi mdi-comment-text"></i> Sisemine memo
            </a>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card mb-3">
          <div class="card-body" v-if="hasDeclarationsBlock">
            <h4 class="card-title mt-0 mb-2">Deklaratsioonid
              <span v-if="invoice.declarations.length > 0" class="badge badge-secondary-light badge-lg ml-1">{{invoice.declarations.length}}</span>
            </h4>
            <table class="table table-sm table-expandable mb-0" v-if="invoice.declarations.length">
              <thead>
                <tr>
                  <th class="border-top-0"></th>
                  <th class="border-top-0">Aktsepteerimise nr.</th>
                  <th class="border-top-0">Kuupäev</th>
                  <th class="border-top-0">Info</th>
                  <th class="border-top-0" width="5%">Lisakaubad</th>
                  <th class="border-top-0 text-right" width="25%">Maksud</th>
                </tr>
              </thead>
              <tbody>
                <template  v-for="declaration in invoice.declarations">
                  <tr :class="{'table-row-expanded': visibleDeclarationIds[declaration.id]}">
                    <td width="10px">
                      <a href="" @click.prevent="toggleDeclarationDetails(declaration)" v-if="declaration.id">
                        <i class="mdi mdi-arrow-down-drop-circle" v-if="!visibleDeclarationIds[declaration.id]"></i>
                        <i class="mdi mdi-arrow-up-drop-circle" v-if="visibleDeclarationIds[declaration.id]"></i>
                      </a>
                    </td>
                    <td>
                      {{declaration.customsReference}}
                      <a @click="deleteDeclaration(declaration)" class="action-icon ml-1" v-if="isDraft">
                        <i class="mdi mdi-delete"></i>
                      </a>
                    </td>
                    <td><span v-if="declaration.createdAt">{{declaration.createdAt | formatDate}}</span></td>
                    <td>{{declaration.summary}}</td>
                    <td class="text-center">{{declaration.extraProductCount}}</td>
                    <td class="p-0">

                      <table class="table table-sm w-auto ml-auto mb-0">
                        <tbody>
                          <tr v-for="(tax, i) in declaration.taxes">
                            <td :class="{'border-top-0': i === 0}">{{tax.name}}</td>
                            <td :class="{'border-top-0': i === 0}" class="text-right">{{tax.amount | amountWithCurrency}}</td>
                            <td :class="{'border-top-0': i === 0}" class="text-right" v-if="invoice.canEditTaxAmount || isDraft">
                              <a @click="editTaxAmount(declaration, tax)" class="action-icon" v-if="invoice.canEditTaxAmount">
                                <i class="mdi mdi-pencil"></i>
                              </a>
                              <a @click="deleteTax(declaration, tax)" class="action-icon" v-if="isDraft">
                                <i class="mdi mdi-delete"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </td>
                  </tr>
                  <tr v-if="visibleDeclarationIds[declaration.id]" class="table-row-expanded-content">
                    <td colspan="6">
                      <declaration-invoicing-details :declarationId="declaration.id" ref="declarationsDetails"/>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div v-else class="mb-1">
              Deklaratsioonid puuduvad
            </div>
            <div>
              <a href="#" @click.prevent="addDeclaration" class="card-link text-primary" v-if="isDraft">
                <i class="mdi mdi-plus"></i>Lisa deklaratsioon
              </a>
              <a href="#" @click.prevent="addAllDeclarations" class="card-link text-primary" v-if="isDraft">
                <i class="mdi mdi-plus"></i>Lisa kliendi deklaratsioonid
              </a>
            </div>
          </div>

          <div class="card-body">
            <h4 class="card-title mt-0 mb-2">Teenused</h4>
            <table class="table table-sm mt-3 mb-0" v-if="invoice.providedServices.length">
              <thead>
                <tr>
                  <th class="border-top-0">Nimi</th>
                  <th class="border-top-0 text-right">Ühiku hind</th>
                  <th class="border-top-0 text-right">Kogus</th>
                  <th class="border-top-0 text-right">Allahindluse&nbsp;%</th>
                  <th width="border-top-0 15%" class="border-top-0  text-right">Kokku</th>
                  <th class="border-top-0 text-right">KM</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in invoice.providedServices">
                  <td>{{service.name}}</td>
                  <td class="text-right">{{service.price | amountWithCurrency}}</td>
                  <td class="text-right">{{service.quantity}}</td>
                  <td class="text-right">{{service.discount === 0 ? '' : service.discount}}</td>
                  <td class="text-right">{{service.totalPrice | amountWithCurrency}}</td>
                  <td class="text-right">{{service.vat}} %</td>
                  <td class="text-right" v-if="isDraft">
                    <a href="#" @click.prevent="editService(service, index)" class="action-icon">
                      <i class="mdi mdi-pencil"></i>
                    </a>
                    &nbsp;
                    <a href="#" @click.prevent="deleteService(service, index)" class="action-icon">
                      <i class="mdi mdi-delete"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <a href="#" @click.prevent="addService" class="card-link text-primary" v-if="isDraft">
              <i class="mdi mdi-plus"></i>
              Lisa teenus
            </a>
          </div>

          <div class="card-body" v-if="isAdvancePaymentInvoice">
            <h4 class="card-title mt-0 mb-2">Riigimaksud</h4>
            <table class="table table-sm mt-3 mb-0" v-if="invoice.tollTaxes.length">
              <thead>
                <tr>
                  <th class="border-top-0">Nimi</th>
                  <th class="border-top-0 text-right">Ühiku hind</th>
                  <th class="border-top-0 text-right">Kogus</th>
                  <th width="border-top-0 15%" class="border-top-0  text-right">Kokku</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in invoice.tollTaxes">
                  <td>{{service.name}}</td>
                  <td class="text-right">{{service.price | amountWithCurrency}}</td>
                  <td class="text-right">{{service.quantity}}</td>
                  <td class="text-right">{{service.totalPrice | amountWithCurrency}}</td>
                  <td class="text-right" v-if="isDraft">
                    <a href="#" @click.prevent="editService(service, index)" class="action-icon">
                      <i class="mdi mdi-pencil"></i>
                    </a>
                    &nbsp;
                    <a href="#" @click.prevent="deleteTollTax(service, index)" class="action-icon">
                      <i class="mdi mdi-delete"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <a href="#" @click.prevent="addTollTax" class="card-link text-primary" v-if="isDraft">
              <i class="mdi mdi-plus"></i>
              Lisa teenus
            </a>
          </div>

          <div class="card-body">

            <div class="row" v-if="invoice.comment">
              <div class="col-12">
                <div class="data-list">
                  <dl>
                    <dt>Kommentaar</dt>
                    <dd>{{invoice.comment}}</dd>
                  </dl>
                </div>
              </div>
            </div>

            <a href="#" @click.prevent="editComment" class="card-link text-primary" v-if="isDraft">
              <i class="mdi mdi-pencil mr-1"></i> Kommentaar
            </a>

          </div>

          <div class="card-body">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
              <tr v-if="invoice.totalTollTax">
                <td></td>
                <td class="text-muted border-bottom">Vahendatav riigimaks</td>
                <td class="text-right border-bottom">{{invoice.totalTollTax | amountWithCurrency}}</td>
              </tr>
              <tr v-if="invoice.declarationsTaxesTotalPrice">
                <td></td>
                <td class="border-bottom text-muted">Vahendatav riigimaks</td>
                <td class="border-bottom text-right">{{invoice.declarationsTaxesTotalPrice | amountWithCurrency}}</td>
              </tr>
              <template v-for="(amount,rate) in invoice.vatByRate">
                <tr>
                  <td></td>
                  <td class="text-muted border-bottom">{{rate | formatVatRate}}% teenused km-ta</td>
                  <td class="text-right border-bottom">{{invoice.servicesSumByVatRate[rate] | amountWithCurrency}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-muted border-bottom">Teenuste km {{rate | formatVatRate}}% </td>
                  <td class="text-right border-bottom">{{amount | amountWithCurrency}}</td>
                </tr>
              </template>
              <tr>
                <td></td>
                <td width="20%"><strong class="h5">Tasuda</strong></td>
                <td width="15%" class="text-right"><strong class="h5">{{invoice.totalPrice | amountWithCurrency}}</strong></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="!isDraft">
        <div class="card mb-1">
          <div class="card-body">
            <h4 class="card-title mt-0 mb-2">Laekumised</h4>
            <table class="table table-sm mb-0">
              <thead>
              <tr>
                <th class="border-top-0">Lisatud</th>
                <th class="border-top-0">Kommentaar</th>
                <th class="border-top-0">Laekunud</th>
                <th class="border-top-0">Laekumise Nr</th>
                <th class="border-top-0 text-right">Summa</th>
                <th class="border-top-0"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="transaction in transactions.rows">
                <td>{{transaction.importedAt | formatDateTime}}</td>
                <td>{{transaction.paymentMode}}</td>
                <td>
                  <span v-if="transaction.receivedAt">{{transaction.receivedAt | formatDate}}</span>
                </td>
                <td>{{transaction.booksSerialNo}}</td>
                <td class="text-right">{{transaction.amount | amountWithCurrency}}</td>
                <td style="padding: 0.2rem;">
                  <button v-if="transaction.booksSerialNo" type="button" class="btn btn-sm" @click="refreshTransaction(transaction.booksSerialNo)">
                    <i class="mdi mdi-refresh"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <td colspan="5" class="text-right">
                  <span class="h5">Saldo: <strong>{{transactions.balance | amountWithCurrency}}</strong></span>
                </td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-link text-danger" @click="deleteInvoice" v-if="isDraft">
          <i class="mdi mdi-delete"></i> Kustuta arve
        </button>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-primary ml-auto" @click="confirmInvoice"  v-if="isDraft">
          <i class="mdi mdi-check"></i> Kinnita...
        </button>
      </div>
    </div>

    <modal ref="addServiceModal" title="Lisa teenus" size="md" @ok="serviceAdded">
      <add-invoice-service :invoice="invoice" :hide-vat="data.tollTax === true" :hide-discount="data.tollTax === true"
                           :service-choices="data.tollTax === true ? tollTaxChoices : serviceChoices" slot-scope="{close, visible, data}" @done="close" v-if="visible"/>
    </modal>
    <modal ref="editServiceModal" title="Muuda teenust" size="md" @ok="serviceUpdated">
      <edit-invoice-service :invoice="invoice" :hide-vat="data.type=='TollTax'" :hide-discount="data.type=='TollTax'" :service="data" slot-scope="{data, close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="editDueDaysModal" title="Muuda tähtaega" size="md" @ok="loadData">
      <edit-invoice-due-days :invoice="invoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="editCommentModal" title="Sisesta kommentaar" size="lg" @ok="loadData">
      <edit-invoice-comment :invoice="invoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="selectInvoicePrefixModal" title="Vali objekt" size="md" @ok="loadData">
      <select-invoice-prefix :invoice="invoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="confirmModal" title="Kinnita arve" size="md" @ok="invoiceConfirmed">
      <confirm-invoice :invoice="invoice" :invoice-date-readonly="isAdvancePaymentInvoice" :due-days-readonly="isAdvancePaymentInvoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="addDeclarationModal" title="Lisa deklaratsioon" size="md" @ok="loadData">
      <add-declaration :invoice="invoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="changeClientModal" title="Muuda arve saaja" size="md" @ok="loadData">
      <change-client :invoice="invoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="changeVatinModal" title="Muuda saaja KMKR" size="md" @ok="loadData">
      <change-vatin :invoice="invoice" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="sendInvoiceModal" title="Saada arve e-mailiga" size="lg" @ok="loadData">
      <send-invoice :invoice="invoice" slot-scope="{close, visible, setTitle}" @title="setTitle" @done="close" v-if="visible"/>
    </modal>

    <modal ref="editTaxAmountModal" title="Muuda maksu summat" size="md" @ok="loadData">
      <edit-tax-amount slot-scope="{data, close, visible}" :data="data" @done="close" v-if="visible"/>
    </modal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import gateway from '../services/gateway'
  import AddInvoiceService from '../components/invoice/AddInvoiceService'
  import EditInvoiceService from '../components/invoice/EditInvoiceService'
  import Modal from '../components/Modal'
  import EditInvoiceDueDays from '../components/invoice/EditInvoiceDueDays'
  import EditInvoiceComment from '../components/invoice/EditInvoiceComment'
  import SelectInvoicePrefix from '../components/invoice/SelectInvoicePrefix'
  import AddDeclaration from '../components/invoice/AddDeclaration'
  import ConfirmInvoice from '../components/invoice/ConfirmInvoice'
  import EditTaxAmount from '../components/invoice/EditTaxAmount'
  import ChangeClient from '../components/invoice/ChangeClient'
  import ChangeVatin from '../components/invoice/ChangeVatin'
  import SendInvoice from '../components/invoice/SendInvoice'
  import DeclarationInvoicingDetails from '@/components/declaration/DeclarationInvoicingDetails'
  import InvoiceStatusStyleClass from '../mixins/InvoiceStatusStyleClass'

  function setHighlighted(pricelist, frequentServiceIds) {
    pricelist.forEach(p => {
      if (frequentServiceIds.indexOf(p.serviceId) >= 0) p.highlighted = true;
    })
    return pricelist
  }

  function sortByNameAsc(pricelist) {
    pricelist.sort((a, b) => {
      if (a.serviceName < b.serviceName) return -1;
      if (a.serviceName === b.serviceName) return 0;
      return 1;
    })
    return pricelist
  }

  export default {
    mixins: [InvoiceStatusStyleClass],
    props: ['id'],
    components: {DeclarationInvoicingDetails, AddInvoiceService, EditInvoiceService, Modal, EditInvoiceDueDays, ConfirmInvoice,
      EditInvoiceComment, SelectInvoicePrefix, AddDeclaration, ChangeClient, ChangeVatin, SendInvoice, EditTaxAmount},
    data() {
      return {
        invoice: {
          typeCode: '',
          client: {address: {country: {}}},
          providedServices: [],
          download: {},
          createdBy: {},
          declarations: [],
          lastEmail: {},
          creditInvoices: []
        },
        serviceChoices: [],
        tollTaxChoices: [],
        visibleDeclarationIds: {},
        transactions: {rows: []}
      }
    },
    methods: {
      goToClient() {
        this.$store.commit('client', {id: this.invoice.client.id, name: this.invoice.client.name})
        this.$router.push('/client')
      },
      changeClient() {
        this.$refs.changeClientModal.show()
      },
      changeReceipientDetails() {
        this.$prompt('Saaja detailid',
          (details) => {
            gateway.post(`/invoices/${this.id}/receipient-details`, {details}).then(() => {
              this.$notifications.info(`Saaja detailid on uuendatud`)
              this.loadData()
            })
          },
          {value: this.invoice.receipientDetails, required: false})
      },
      changeVatin() {
        this.$refs.changeVatinModal.show()
      },
      editPaymentDueDays() {
        this.$refs.editDueDaysModal.show()
      },
      editComment() {
        this.$refs.editCommentModal.show()
      },
      selectInvoicePrefix() {
        this.$refs.selectInvoicePrefixModal.show()
      },
      addService() {
        this.$refs.addServiceModal.show({})
      },
      addTollTax() {
        this.$refs.addServiceModal.show({tollTax: true})
      },
      serviceAdded(service) {
        if (service.type === 'TollTax')
          this.invoice.tollTaxes.push(service)
        else
          this.invoice.providedServices.push(service)

        this.saveProvidedServices().then(() => {
          if (service.type === 'TollTax') {
            this.$notifications.info('Riigimaks arvele lisatud')
          }
          else {
            this.$notifications.info('Teenus arvele lisatud')
          }
        })
      },
      editService(service) {
        this.$refs.editServiceModal.show(service)
      },
      serviceUpdated() {
        this.saveProvidedServices().then(this.$notifications.info('Teenus on muudetud'))
      },
      deleteService(service, index) {
        this.$confirm('Kustutame teenuse rea ' + service.name + ' summas ' + service.totalPrice + ' € ?', () => {
          this.invoice.providedServices.splice(index, 1)
          this.saveProvidedServices()
            .then(this.$notifications.info('Teenus ' + service.name + ' on kustutatud'))
        })
      },
      deleteTollTax(service, index) {
        this.$confirm('Kustutame riigimaksu rea ' + service.name + ' summas ' + service.totalPrice + ' € ?', () => {
          this.invoice.tollTaxes.splice(index, 1)
          this.saveProvidedServices()
            .then(this.$notifications.info('Riigimaks ' + service.name + ' on kustutatud'))
        })
      },
      saveProvidedServices() {
        let providedServices = this.invoice.providedServices.concat(this.invoice.tollTaxes)
        return gateway.post(`/invoices/${this.id}/services`, {providedServices: providedServices}).then(r => {
          this.loadData()
        })
      },
      refreshTransaction(booksSerialNo) {
        gateway.post(`/transactions/by_serial/${booksSerialNo}/refresh`).then(() => {
          this.$notifications.info(`Laekumine ${booksSerialNo} on uuendatud`)
          this.loadData()
        })
      },
      addDeclaration() {
        this.$refs.addDeclarationModal.show()
      },
      addAllDeclarations() {
        gateway.post(`/invoices/${this.id}/add-unprocessed-declarations`).then(r => {
          let count = Number(r.data)
          if (count === 0)
            this.$notifications.warning('Töötlemata deklaratsioone ei leitud')
          else
            this.$notifications.info(`${r.data} deklaratsiooni lisati arvele`)
          this.loadData()
        })
      },
      loadData(invoiceId) {
        invoiceId = invoiceId || this.id

        gateway.get(`/invoices/${invoiceId}`).then(r => {
            this.invoice = r.data
            if (this.isDraft) {
              this.loadPricelist(this.invoice.client.id)
            } else {
              gateway.get(`/invoices/${invoiceId}/transactions`).then(r => this.transactions = r.data)
            }
            this.$emit('reload-declarations')
          })
      },
      loadPricelist(clientId){
        Promise.all([
          gateway.get(`/clients/${clientId}/pricelist`),
          gateway.get(`/clients/${clientId}/frequent-services-on-invoice`)
        ]).then(([pricelistResult, frequentServicesResult]) => {
          this.serviceChoices = sortByNameAsc(setHighlighted(pricelistResult.data, frequentServicesResult.data))
        })

        gateway.get(`/clients/${clientId}/pricelist`, {params: {tollTaxes: true}})
          .then(r => {
            this.tollTaxChoices = r.data
            this.tollTaxChoices.forEach(t => t.type = 'TollTax')
          })
      },
      confirmInvoice() {
        this.$refs.confirmModal.show()
      },
      unConfirm() {
        this.$confirm('Oled kindel, et soovid arvet avada?', () => {
          gateway.post(`/invoices/${this.invoice.id}/unconfirm`)
            .then(() => {
              this.$notifications.info('Arve uus staatus on mustand')
              this.loadData()
            })
            .catch(r => this.$notifications.error(r.response.data.key))
        })
      },
      setCreditPaid() {
        this.$confirm('Oled kindel, et soovid määrata arvet makstuks?', () => {
          gateway.post(`/invoices/${this.invoice.id}/credit-set-paid`)
            .then(() => {
              this.$notifications.info('Arve on määratud makstuks')
              this.loadData()
            })
            .catch(r => this.$notifications.error(r.response.data.key))
        })
      },
      invoiceConfirmed() {
        this.$notifications.info('Arve on kinnitatud')
        this.loadData()
      },
      downloadInvoice() {
        window.open(`/api/invoices/${this.invoice.id}/pdf`)
      },
      deleteInvoice() {
        this.$confirm(`Kustutame arve mustandi nr ${this.invoice.number} ?`, () => {
          gateway.delete(`/invoices/${this.invoice.id}`).then(r => {
            this.$notifications.info(`Arve ${this.invoice.number} on kustutatud`)

            if (this.invoice.creditedInvoiceId)
              this.$router.replace(`/invoices/${this.invoice.creditedInvoiceId}`)
            else
              this.$router.replace('/invoices')
          })
        })
      },
      cloneInvoice() {
        gateway.post(`/invoices/${this.invoice.id}/clone`).then(r => {
          this.$router.push(`/invoices/${r.data}`)
          this.$notifications.info('Arve on kloonitud')
        })
      },
      creditInvoice() {
        gateway.post(`/invoices/${this.invoice.id}/clone`, {credit: true}).then(r => {
          this.$router.push(`/invoices/${r.data}`)
          this.$notifications.info('Kreeditarve loodud, vaadake üle')
        })
      },
      editTaxAmount(declaration, tax) {
        this.$refs.editTaxAmountModal.show({
          amount: tax.amount,
          groupName: tax.groupName,
          name: tax.name,
          declarationId: declaration.id,
          invoiceId: this.invoice.id
        })
      },
      deleteDeclaration(declaration) {
        this.$confirm(`Kas soovid eemaldada deklaratsiooni ${declaration.customsReference} arvelt?`,() => {
          gateway
            .post(`/invoices/${this.invoice.id}/remove-declaration`, {declarationId: declaration.id})
            .then(() => {
              this.$notifications.info(`Deklaratsioon on eemaldatud`)
              this.loadData()
            })
        })
      },
      deleteTax(declaration, tax) {
        this.$confirm(`Kas soovid eemaldada deklaratsiooni ${declaration.customsReference} maksu "${tax.name}" arvelt?`,() => {
          gateway
            .post(`/invoices/${this.invoice.id}/remove-tax`, {declarationId: declaration.id, groupName: tax.groupName})
            .then(() => {
              this.$notifications.info(`Rida on eemaldatud`)
              this.loadData()
            })
        })
      },
      toggleDeclarationDetails(declaration) {
        Vue.set(this.visibleDeclarationIds, declaration.id, !this.visibleDeclarationIds[declaration.id])
      },
      sendInvoice() {
        this.$refs.sendInvoiceModal.show()
      },
      deleteInternalMemo(id) {
        this.$confirm('Kas soovid kustutata sisemist memot?', () => {
          this.$gateway.delete(`/invoices/${this.invoice.id}/internal-memos/${id}`).then(() => {
            this.$notifications.info(`Memo on kustutatud`)
            this.loadData()
          })
        })
      },
      addInternalMemo() {
        this.$prompt('Sisestage sisemine memo', (value) => {
          this.$gateway.post(`/invoices/${this.invoice.id}/internal-memos`, {memo: value})
            .then(r => {
              this.loadData()
              this.$notifications.info('Memo on lisatud')
            })
        } )
      }
    },
    created() {
      this.loadData()
    },
    computed: {
      hasDeclarationsBlock() {
        return !this.isAdvancePaymentInvoice
      },
      isAdvancePaymentInvoice() {
        return this.invoice.typeCode === 'advance'
      },
      canSetCreditPaid() {
        return this.invoice.typeCode === 'credit' &&
          (this.invoice.statusCode === 'confirmed' || this.invoice.statusCode === 'debt')
      },
      isDraft() {
        return this.invoice.statusCode === 'draft'
      },
      canUnconfirm() {
        return this.invoice.exportedAt == null &&
          (this.invoice.statusCode === 'confirmed' || this.invoice.statusCode === 'debt')
      }
    },
    watch: {
      'id'(newId) {
        this.loadData(newId)
      }
    },
  }
</script>
